import { Component, OnInit, Inject } from '@angular/core';
import { UtilityService } from '../../../services/utility.service';
import {
  IAccountInboxInvite,
  IFunnelStep,
  IUtility,
} from '../../../interfaces/graph-types';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription, Subject } from 'rxjs';
import { ModalCreateCustomInboxComponent } from '../../modals/custom-inbox-settings/modal-create-custom-inbox.component';
import { SpeedTestService } from 'ng-speed-test';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: '[apply]',
  template: require('./apply.component.pug'),
  styles: [require('./apply.component.css').toString()],
})
export class GuestApplyComponent implements OnInit {
  csrf = '';

  accountId: string = null;
  funnelId: string;
  source: string = null;

  funnel: IFunnelStep = null;
  currentStep: IFunnelStep = null;

  bsModalRef: BsModalRef;
  subReason: Subscription = null;
  sub: Subscription = null;

  isLoading = true;

  internetSpeed: number = null;

  public reason: Subject<any>;

  // -------------------------------------------------------------------
  constructor(
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private route: ActivatedRoute,
    private utilityService: UtilityService,
    private modalService: BsModalService,
    private speedTestService: SpeedTestService,
    private cookieService: CookieService,
  ) {
    this.reason = new Subject();
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.csrf = this.document.querySelector("meta[name='csrf-token']").content;

    const params = this.route.snapshot.params;
    this.accountId = params['account_id'];
    this.funnelId = params['funnel_id'];
    this.source = params['source'];
    this.cookieService.set('source', this.source);

    // this.sub = this.utilityService
    //   .getFunnelStep(this.funnelId)
    //   .subscribe(res => {
    //     this.funnel = res;
    //     if (res) this.isLoading = false;
    //   });

    this.speedTestService.getMbps().subscribe(speed => {
      this.internetSpeed = Math.floor(speed);
      this.isLoading = false;
      console.log('Your speed is ' + speed);
    });

    // this.sub = this.service
    //   .accountInboxInvite(this.accountId, this.source)
    //   .subscribe(res => {
    //     if (!res.accountInboxInvite) {
    //       this.router.navigate(['/guest/account/inboxes/error'], {
    //         queryParams: { error: 'invalid_link' },
    //       });
    //     }
    //     this.utility = res;
    //   });
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
    if (this.subReason) this.subReason.unsubscribe();
  }

  // -------------------------------------------------------------------
  start(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.utilityService.startFunnel(
      this.funnelId,
      this.internetSpeed,
      this.source,
      res => {
        // onsuccess();
        // debugger

        this.router.navigateByUrl('/proceed/' + res.applicationId);

        // window.location.href = '/proceed/' + res.applicationId;

        // this.isLoading = true;
        // if (this.sub) this.sub.unsubscribe();
        // this.sub = this.utilityService
        //   .getFunnelStep(this.funnelId)
        //   .subscribe(res => {
        //     this.funnel = res;
        //     this.isLoading = false;
        //   });
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  getPath(oauth) {
    return (
      '/auth/' +
      oauth +
      '?apply=true&account_id=' +
      this.accountId +
      '&funnel_id=' +
      this.funnelId +
      '&source=' +
      this.source
    );
  }

  // -------------------------------------------------------------------
  addCustomInbox() {
    // const options: ModalOptions = new ModalOptions();
    // options.class = 'gray modal-lg';
    // options.ignoreBackdropClick = true;
    // options.initialState = {
    //   accountId: this.accountId,
    //   secret: this.secret,
    // };
    // this.bsModalRef = this.modalService.show(
    //   ModalCreateCustomInboxComponent,
    //   options,
    // );
    // this.bsModalRef.content.closeBtnName = 'Close';
    // this.subReason = this.bsModalRef.content.reason.subscribe(res => {
    //   this.bsModalRef.hide();
    //   this.reason.next(res);
    //   if (res.inboxId) {
    //     const fromName =
    //       this.utility.accountInboxInvite &&
    //       this.utility.accountInboxInvite.fromName;
    //     this.router.navigate(['/guest/account/inboxes/success'], {
    //       queryParams: { notified: fromName },
    //     });
    //   }
    // });
  }
}
